import React from 'react';
import { Panel } from '../onyx/Panel';
import { SectionHeader } from '../onyx/SectionHeader';
/**
 * Read-only recap of a participant's pre-screen / questionnaire answers.
 */
export const PreScreenSection = ({
  data,
  completedAt,
  title = 'Pre-Screen Responses',
  description = null,
  eyebrow = null,
  action = null,
  loading = false,
}) => {
  if (loading || !data) {
    return (
      <Panel className="dashboard-section">
        <SectionHeader title={title} description="Loading..." />
      </Panel>
    );
  }
  if (Object.keys(data).length === 0) {
    return null;
  }
  const resolvedDescription =
    description
    || (completedAt
      ? `Completed on ${new Date(completedAt).toLocaleDateString()}`
      : null);
  return (
    <Panel className="dashboard-section">
      {eyebrow ? <p className="optional-steps__kind">{eyebrow}</p> : null}
      <SectionHeader title={title} description={resolvedDescription} />
      <div className="onyx-detail-list">
        {Object.entries(data).map(([id, entry]) => (
          <div key={id} className="onyx-detail-row onyx-detail-row--qa">
            <span className="onyx-detail-label">{entry.question}</span>
            <span className="onyx-detail-value">{formatAnswer(entry.answer)}</span>
          </div>
        ))}
      </div>
      {action ? <div className="dashboard-section__actions">{action}</div> : null}
    </Panel>
  );
};

const formatAnswer = (answer) => {
  if (Array.isArray(answer)) return answer.join(', ');
  if (typeof answer === 'boolean') return answer ? 'Yes' : 'No';
  if (answer === null || answer === undefined || answer === '') return '—';
  if (typeof answer === 'object') {
    const parts = [
      answer.address_1,
      answer.address_2,
      [answer.city, answer.state].filter(Boolean).join(', '),
      answer.zip_code,
    ].filter((part) => part && String(part).trim());
    if (parts.length) return parts.join(', ');
    if (answer.approximate_date) return String(answer.approximate_date);
    if (answer.date) return String(answer.date);
    try {
      return JSON.stringify(answer);
    } catch (_err) {
      return '—';
    }
  }
  return String(answer);
};

export default PreScreenSection;
